/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLog = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M20 2v11h-2V4H4v16h9v2H2V2zm-2 12a4 4 0 1 1 0 8 4 4 0 0 1 0-8zm.5 2h-1v2.207l1.146 1.146.707-.707-.853-.854zM8 11v2H6v-2zm8 0v2h-6v-2zM8 7v2H6V7zm8 0v2h-6V7z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgLog as Log };
